module.exports = __webpack_public_path__ + "img/auth_up_zz_img.bad67b4e.png";